import { useQuery } from "@tanstack/react-query";
import { useApi } from "@utils/useApi";
import { type ProductDetailDto, StandardsClient } from "@lib/ShiOneClient";
import ms from "ms";

export const EcommerceQueryKeys = {
  FeaturedProducts: "ecommerce-featured-products",
} as const;

export default function useGetFeaturedProduct(
  viewFeaturedProducts: boolean,
  orgUnitId?: number | null,
  inCatalog?: boolean,
  top?: number,
) {
  const api = useApi(StandardsClient);

  const fetchFeaturedProducts = async (): Promise<
    ProductDetailDto[] | undefined
  > => {
    if (!orgUnitId) return;
    return await api.getFeaturedProductDetails(orgUnitId, inCatalog, top);
  };

  return useQuery({
    queryKey: [EcommerceQueryKeys.FeaturedProducts, orgUnitId, inCatalog, top],
    queryFn: fetchFeaturedProducts,
    enabled: viewFeaturedProducts && !!orgUnitId,
    staleTime: ms("30s"),
  });
}
